<template>
  <header
    v-if="headerModel"
    class="header"
    :class="{
      'header--android': $isAndroid,
      'header--ios': !$isAndroid,
      'header--shadow': headerModel.shadowed,
      [headerModel.additionalClass]: headerModel.additionalClass,
    }"
  >
    <slot name="indicator"></slot>
    <div class="header__head" @click="$emit('back-action')">
      <div class="header__head_wrapper">
        <slot name="back-icon">
          <div :class="`i-back-${$isAndroid ? 'android' : 'ios'}`"></div>
        </slot>
      </div>
    </div>
    <div
      class="header__title"
      :class="{
        'header__title--full': !headerModel.tail && !$slots.tail,
      }"
    >
      <div
        v-if="headerModel.logo"
        class="header__title_logo"
        :class="headerModel.logo"
      ></div>
      <div class="header__title_text">
        {{ headerModel.title }}
      </div>
    </div>
    <div
      v-if="headerModel.tail || $slots.tail"
      class="header__tail"
      @click="$emit('tail-action')"
    >
      <slot name="tail">
        <div :class="headerModel.tail.icon"></div>
      </slot>
    </div>
  </header>
</template>

<script>
import "@/jsdoc/types";

export default {
  props: {
    headerModel: {
      /**
       * @type {import('vue').PropType<HeaderModel>}
       */
      type: [Object, null],
      required: true,
    },
  },
  emits: ["back-action", "tail-action"],
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.header {
  position: relative;
  display: flex;
  align-items: center;
  background-color: white;
  z-index: 1;

  &__tail {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &--android {
    height: 56px;
    font-size: 20px;
    line-height: 24px;

    &.header--shadow {
      position: relative;
      z-index: 2000000000;
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15);
    }

    .header__title {
      &_text {
        font-family: Roboto-Medium;
        display: block;
        text-align: left;
        width: calc(100vw - 44px);
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .header__head {
      &_wrapper {
        padding: 0 20px;
        min-width: 72px;
      }
    }
  }

  &--ios {
    height: 48px;
    font-size: 17px;
    line-height: 20px;

    &.header--shadow {
      border-bottom: 1px solid $colorWhiteSmokeDarker;
    }

    .header__title {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 48px;
      width: 100%;

      &--full {
        padding-right: 20px;
      }

      &_logo {
        margin-right: 10px;
      }

      &_text {
        font-family: Roboto-Medium;
        display: block;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
      }
    }

    .header__head {
      position: absolute;
      left: 15px;
      font-size: 17px;
      line-height: 20px;
      color: $colorRed;
    }
  }

  // TODO: Rethink
  .header__tail {
    position: absolute;
    right: 0;
    height: 100%;
    width: 50px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
